import { useCallback } from 'react';
import { usePostHog } from 'posthog-js/react';

import {
  captureAttributesToProperties,
  getActionType,
  getEventName,
  getTrackerId,
  POSTHOG_PROPERTIES,
  TRACKER_IDS,
} from '../../config/tracker';
import IconCircled, { ICON_CIRCLE_SIZE } from '../IconCircled';
import DealSvg from '../SvgComponents/Deal_svg';
import TCCoinSvg from '../SvgComponents/TCCoin_svg';

import './RewardsStoreCard.scss';
import { formatReadableNumber } from '../../utils/numbers';

const {
  rewards: {
    list: {
      storeItem: trackerStoreItem,
    },
  },
} = TRACKER_IDS;

const RewardsStoreCard = ({
  index,
  store,
  onClick,
  trackerProps = {},
}) => {
  const posthog = usePostHog();

  const {
    id,
    title,
    logoUrl,
    imgUrl,
    tcCreditAmount = '0',
    tcCreditAmountType,
    cardBgColor,
    activeRewardsCount,
  } = store;

  const tcAmount = Number(tcCreditAmount) || 0;

  const getTcDisplayText = () => formatReadableNumber(tcAmount);

  const getTcCreditText = () => {
    if (tcCreditAmountType === 'PERCENTAGE') return `Up to ${formatReadableNumber(tcAmount * 100)}%`;
    if (tcCreditAmountType === 'VALUE') return `Up to $${getTcDisplayText()}`;
    return 'Earn TC';
  };

  const handleOnClick = useCallback(() => {
    posthog.capture(
      getEventName(trackerStoreItem),
      {
        [POSTHOG_PROPERTIES.TRACKER_ID]: getTrackerId(trackerStoreItem),
        [POSTHOG_PROPERTIES.ACTION_ID]: getActionType(trackerStoreItem),
        [POSTHOG_PROPERTIES.STORE_ID]: id,
        [POSTHOG_PROPERTIES.STORE_NAME]: title,
        ...(index != null && !Number.isNaN(Number(index)) && {
          [POSTHOG_PROPERTIES.LIST_POSITION]: Number(index) + 1,
        }),
        ...captureAttributesToProperties(trackerProps),
      },
    );

    onClick?.(store, index);
  }, [posthog, id, title, store, onClick, index, trackerProps]);

  return (
    <button
      className="RewardsStoreCard"
      onClick={handleOnClick}
      type="button"
      aria-label="store card"
    >
      <div
        className="RewardsStoreCard__top"
        style={{
          backgroundColor: cardBgColor,
          backgroundImage: `url(${imgUrl})`,
        }}
      >
        {activeRewardsCount > 0 && (
          <div className="RewardsStoreCard__top-pill">
            <DealSvg width={16} height={16} />
            <span>{activeRewardsCount === 1 ? '1 Deal' : `${activeRewardsCount} Deals`}</span>
          </div>
        )}
      </div>
      <div className="RewardsStoreCard__center">
        <IconCircled
          size={ICON_CIRCLE_SIZE.MEDIUM_LARGE}
          icon={(
            <img
              src={logoUrl}
              alt={title}
            />
          )}
          backgroundColor={cardBgColor}
          borderColor="var(--ui-gray-light)"
        />
      </div>
      <div className="RewardsStoreCard__bottom">
        <div className="RewardsStoreCard__bottom-tc-credits">
          <p className="RewardsStoreCard__bottom-tc-credits-value">
            <span className="RewardsStoreCard__bottom-tc-credits-number">
              <TCCoinSvg width={12} height={12} />
              {getTcCreditText()}
            </span>
          </p>
        </div>
      </div>
    </button>
  );
};

export default RewardsStoreCard;
